import React, { Component } from "react";
import { Form, FormGroup, FormControl, Button } from "react-bootstrap";
import axios from "axios";
import BaseUrl from "../../Stores/DataStore/Enums/BaseUrl";
import CharacterReplacer from "../../Core/CharacterReplacer";

class Login extends Component {
  constructor(props) {
    super(props);

    this.state = {};
  }

  handleUsernameChange(e) {
    this.setState({ username: e.target.value });
  }

  handlePasswordChange(e) {
    this.setState({ password: e.target.value });
  }

  onKeyPress(e) {
    if (e.key === "Enter") {
      this.login();
    }
  }

  onLoginClick() {
    this.login();
  }

  onForgotPasswordClick() {
    this.props.onRefreshComponent(this.props.loginTypes.REQUESTPASSWORDRESET.Name);
  }

  async login() {
    this.setState({ fetching: true });
    this.setState({ error: null });

    try {
      const username = this.state.username;
      if (!username) throw Error("Email must be filled in!");

      if (!this.state.password) throw Error("Please fill in your password!");
      const password = CharacterReplacer.replaceForbiddenCharacters(this.state.password);

      const baseUrl = new BaseUrl();
      const url = baseUrl.SERVERURL + "/api/public/login.php";

      await axios
        .post(
          url,
          JSON.stringify({
            username: username,
            password: password
          })
        )
        .then(
          async function(response) {
            if (response.data) {
              if (response && response.data) {
                // Notify high-level compontents of status change
                if (this.props.onLoginStatusChanged) {
                  this.props.onLoginStatusChanged(response.data.UserId, response.data.Token);
                }
              }
            }
          }.bind(this)
        )
        .catch(
          function(error) {
            debugger;
            if (error) {
              console.log(error);
              console.log(error.message);
            }

            this.setState({
              error: "Could not log in. Please check your credentials or contact the primary user of your company."
            });
          }.bind(this)
        );
    } catch (error) {
      if (error) {
        console.error(error);
        this.setState({
          error: error.message
        });
      }
    }
    this.setState({ fetching: false });
  }

  render() {
    const { fetching, error } = this.state;

    let errorMessage = null;
    if (error) errorMessage = <div className="alert alert-danger">{error}</div>;

    return (
      <div>
        <h1>Login</h1>
        <Form horizontal>
          <div className="jumbotron">
            <FormGroup controlId="formHorizontalLoginName">
              <FormControl
                disabled={fetching}
                type="name"
                placeholder="Email"
                onChange={this.handleUsernameChange.bind(this)}
                onKeyPress={this.onKeyPress.bind(this)}
              />
            </FormGroup>

            <FormGroup controlId="formHorizontalLoginPassword">
              <FormControl
                disabled={fetching}
                type="password"
                placeholder="Password"
                onChange={this.handlePasswordChange.bind(this)}
                onKeyPress={this.onKeyPress.bind(this)}
              />
            </FormGroup>

            <FormGroup controlId="formHorizontalLoginSubmit">
              <Button bsStyle="primary" disabled={fetching} onClick={this.onLoginClick.bind(this)}>
                Go
              </Button>
            </FormGroup>
          </div>
          {errorMessage}
        </Form>
        <a onClick={this.onForgotPasswordClick.bind(this)}>Forgot password?</a>
      </div>
    );
  }
}

export default Login;



// WEBPACK FOOTER //
// ./src/Components/Login/Login.js